import { Button } from '@mui/material';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import MenuItemText from '../MenuItemText';
import { AppMenuItem } from './types';

interface DesktopMenuItemProps {
    menuItem: AppMenuItem;
    onCloseNavMenu: () => void;
}

/**
 * Desktop menu item component for the main navigation
 */
const DesktopMenuItem: FC<DesktopMenuItemProps> = ({ menuItem, onCloseNavMenu }) => {
    const handleClick = () => {
        onCloseNavMenu();
        if (menuItem.link.startsWith('http')) {
            window.open(menuItem.link, '_blank', 'noopener,noreferrer');
        }
    };

    if (menuItem.link.startsWith('http')) {
        return (
            <Button
                key={menuItem.name}
                onClick={handleClick}
                sx={{
                    my: 2,
                    display: 'block',
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline',
                    }
                }}
            >
                <MenuItemText context="appbar">{menuItem.name}</MenuItemText>
            </Button>
        );
    }

    return (
        <Button
            key={menuItem.name}
            component={Link}
            to={menuItem.link}
            onClick={onCloseNavMenu}
            sx={{
                my: 2,
                display: 'block',
                textDecoration: 'none',
                '&:hover': {
                    textDecoration: 'underline',
                }
            }}
        >
            <MenuItemText context="appbar">{menuItem.name}</MenuItemText>
        </Button>
    );
};

export default DesktopMenuItem;
